import React, { useRef, useState } from "react";
import { Modal } from "react-bootstrap";
import JoditEditor from "jodit-react";
import { toast } from "react-toastify";
import axios from "axios";

const WithdrawalsModal = (props) => {
  const { singledata, setupdateData, setmodalshow } = props;

  const DisRef = useRef(null);
  const [Dis, setDisContent] = useState("");

  const [errorMessage, setErrorMessage] = useState([]);
  const refSubmitDis = useRef();

  const handleReject = (event) => {
    event.preventDefault();
    refSubmitDis.current.setAttribute("disabled", true);
    setErrorMessage("");
    const formData = new FormData(event.currentTarget);
    const InpuData = Object.fromEntries(formData);
    const storeData = { ...InpuData, body: Dis };
    const config = {
      headers: {
        "content-type": "application/json",
      },
    };
    axios
      .put(
        `https://api.wlffinance.org/api/admin/withdrawal/reject/${singledata?._id}`,
        storeData,
        config
      )
      .then((response) => {
        setupdateData(response?.data);
        setmodalshow(false);
        event.target.reset();
        toast.success(`${response?.data.message}`, {
          position: "top-right",
          autoClose: 5000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true,
          progress: undefined,
          theme: "colored",
        });
        refSubmitDis.current.removeAttribute("disabled");
      })
      .catch((error) => {
        refSubmitDis.current.removeAttribute("disabled");
        if (error?.response?.data?.errors) {
          setErrorMessage(error?.response?.data?.errors);
        } else {
          setErrorMessage(error?.response?.data);
        }
      });
  };

  return (
    <>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        backdrop="static"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            <h4 className="modal-title">Withdrawal Reject </h4>
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="row">
            <div className="col-lg-12 col-md-12 mb-30">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleReject}>
                    <div className="row">
                      <div className=" col-md-12 ">
                        <div className="col-md-12">
                          <div className="form-group">
                            <label htmlFor="heading" className="required">
                              Subject
                            </label>
                            <textarea name="subject"></textarea>
                            {errorMessage?.subject && (
                              <span className="text-danger pt-2">
                                {errorMessage?.subject?.msg}
                              </span>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="row">
                      <div className="col-md-12">
                        <div className="form-group">
                          <label htmlFor="button_one_url" className="required">
                            Body
                          </label>
                          <JoditEditor
                            ref={DisRef}
                            value={Dis}
                            height="2600"
                            onChange={(newContent) => setDisContent(newContent)}
                          />

                          {errorMessage?.body && (
                            <span className="text-danger pt-2">
                              {errorMessage?.body?.msg}
                            </span>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="form-group">
                      <button
                        ref={refSubmitDis}
                        type="submit"
                        className="btn btn-primary w-100 h-45"
                      >
                        Submit
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default WithdrawalsModal;
